<template>
  <div class="modal" :class="{ active: visible }" @click.self="handleClose">
    <div class="modal-body" style="width:500px">
      <div style="padding:15px; border-bottom:1px solid #e2e8f0; display:flex; justify-content:space-between">
        <h3>挂单列表</h3>
        <button @click="handleClose" style="border:none;background:none;font-size:1.5rem; cursor:pointer">&times;</button>
      </div>
      <div class="hold-list">
        <div v-if="holdOrders.length === 0" style="text-align:center; padding: 50px; color: #94a3b8;">
          无挂单
        </div>
        <div
          v-for="(order, index) in holdOrders"
          :key="index"
          class="hold-item"
        >
          <span>{{ order.time }} - ¥{{ order.total }}</span>
          <button class="btn-blue" @click="restoreOrder(index)">取单</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HoldOrderModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    holdOrders: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    restoreOrder(index) {
      this.$emit('restore', index)
      this.handleClose()
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  z-index: 1000;
  align-items: center;
  justify-content: center;
}

.modal.active {
  display: flex;
}

.modal-body {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
}

.hold-list {
  padding: 20px;
  max-height: 400px;
  overflow-y: auto;
}

.hold-item {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  padding: 15px;
  margin-bottom: 10px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-blue {
  background: #2563eb;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  font-size: 0.9rem;
}

.btn-blue:hover {
  background: #1d4ed8;
}
</style>

